import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/f1 white.png'


const _hoisted_1 = { id: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "F1 logo",
  src: _imports_0,
  id: "logo"
}, null, -1)

import HamburgerMenu from '../components/HamburgerMenu.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HamburgerMenu),
    _hoisted_2
  ]))
}
}

})